import {CAMPAIGN_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {setShouldAutoArrange} from 'common/src/modules/campaigns/store/campaignLogic/campaignLogic.slice';
import {CLStore} from 'common/src/redux/store';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {cardTypeToName} from '../../../../campaignSetupAgent.config';
import addOrUpdateNodeState, {
  AddOrUpdateNodeStateType,
} from '../../../../utils/addOrUpdateNodeState';
import {PromptToCardAgentStatus} from '../../../promptToCardAgent/promptToCardAgent';
import {SupportedCardType} from '../../promptToCardAgentV2.types';

/**
 * Tries to add or update the card (using API), and reports the results back to the calling agent
 * @param store - Redux store
 * @param cardFromState - The card from the agent scratchpad which was setup by the standalone agent
 * @param cardId - Card ID
 * @param chainOfThoughts - Chain of thoughts
 * @param agentScratchpad - The agent scratchpad accessor to clear after processing
 * @returns - Tool result
 */
export default async function tryPatchingCardAndReportResults(
  store: CLStore,
  cardFromState: SupportedCardType,
  cardId: number,
  chainOfThoughts: string,
) {
  const isExistingCard = cardId > CAMPAIGN_NODE_ID;

  try {
    const resultCardId = await addOrUpdateNodeState(
      store,
      cardFromState,
      isExistingCard ? AddOrUpdateNodeStateType.Update : AddOrUpdateNodeStateType.Add,
    );

    if (!isExistingCard) {
      store.dispatch(setShouldAutoArrange(true));
    }

    const response = `${
      isExistingCard ? 'Updated' : 'Added'
    } ${cardTypeToName[cardFromState.type]} card with id ${resultCardId} successfully. Summary: ${chainOfThoughts}`;

    return toolResult(response);
  } catch (error) {
    return toolResult(
      JSON.stringify({
        status: PromptToCardAgentStatus.NoAction,
        chainOfThoughts,
        error: error.message,
      }),
    );
  }
}
